
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/parents",
      function () {
        return require("private-next-pages/parents.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/parents"])
      });
    }
  